// extracted by mini-css-extract-plugin
export default {"footer_container":"Footer_footer_container__vylNB","pink_span":"Footer_pink_span__+Hw9S"};